import { render } from "./tpluse.vue?vue&type=template&id=251bd6f2&scoped=true"
import script from "./tpluse.vue?vue&type=script&lang=js"
export * from "./tpluse.vue?vue&type=script&lang=js"

import "./tpluse.vue?vue&type=style&index=0&id=251bd6f2&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251bd6f2"]])

export default __exports__